import * as Aphrodite from 'aphrodite/no-important';

import '../../css/base_components.css';

export function css(...args: any) {
  return Aphrodite.css(...args);
}

export function resolveStyle(style: any, extra_class?: any) {
  let className = 'base-component ';
  const inlineStyle: any = {};
  const aphrodite_style_list: any = [];

  function _handleStyle(sub_style: any) {
    if (sub_style && sub_style._name) {
      aphrodite_style_list.push(sub_style);
    } else if (Array.isArray(sub_style)) {
      sub_style.forEach(_handleStyle);
    } else if (typeof sub_style === 'object' && sub_style) {
      Object.assign(inlineStyle, sub_style);
    }
  }
  _handleStyle(style);
  if (aphrodite_style_list.length > 0) {
    className += css(aphrodite_style_list);
  }
  if (extra_class) {
    className += ' ' + extra_class;
  }
  return { className, inlineStyle };
}

function _createStyleSheet<T>(style_map: T): T {
  return Aphrodite.StyleSheet.create(style_map as any) as T;
}

const styles = _createStyleSheet({
  absoluteFill: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 },
});

export const StyleSheet = {
  create: _createStyleSheet,
  absoluteFill: styles.absoluteFill,
  absoluteFillObject: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  hairlineWidth: 1 / (window?.devicePixelRatio ?? 1),
};
